import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { ProjectThumb } from "./ProjectCard";

export const FILTERS = [
  { key: "all", label: "Hamısı" },
  { key: "web_site", label: "Veb saytlar" },
  { key: "web_app", label: "Veb tətbiqlər" },
  { key: "mobile_app", label: "Mobil tətbiqlər" },
  { key: "design", label: "Dizayn" },
  { key: "logo", label: "Loqolar" },
  { key: "telegram_bot", label: "Telegram botlar" },
  { key: "tiktok_game", label: "TikTok canlı yayım oyunları" },
];

export default function AllWorks({ standalone = false }) {
  const { projects } = useSite();
  const [f, setF] = useState("all");
  const step = standalone ? 12 : 8;
  const [limit, setLimit] = useState(step);
  const list = f === "all" ? projects : projects.filter((p) => p.category === f);
  const pick = (k) => { setF(k); setLimit(step); };
  const H = standalone ? "h1" : "h2";
  return (
    <section data-testid="all-works-section" className={`bg-[#EEE7DC]/60 ${standalone ? "pt-32 pb-24" : "py-16 md:py-20"}`}>
      <div className="container-lm">
        <div className="flex flex-col gap-6">
          <div>
            <H className={`font-display font-semibold ${standalone ? "text-4xl sm:text-5xl" : "text-2xl sm:text-3xl"}`}>Bütün işlərimiz</H>
            <p className="text-sm text-[#77736B] mt-3 max-w-sm leading-relaxed">Bütün layihələrə baxın və öz ideyanız üçün ilham alın.</p>
          </div>
          <div className="flex gap-2 lg:gap-3 overflow-x-auto no-scrollbar -mx-5 px-5 lg:mx-0 lg:px-0" role="tablist" aria-label="Kateqoriya filtri">
            {FILTERS.map((x) => (
              <button key={x.key} role="tab" aria-selected={f === x.key} onClick={() => pick(x.key)} data-testid={`filter-${x.key}`}
                className={`shrink-0 whitespace-nowrap lg:flex-auto text-xs lg:text-[13px] xl:text-sm font-medium px-5 lg:px-4 xl:px-6 py-2.5 lg:py-3.5 rounded-full border transition-colors ${f === x.key ? "bg-[#171715] text-[#F7F3EB] border-[#171715]" : "bg-white/70 border-[#171715]/10 hover:border-[#171715]/40 hover:bg-white"}`}>
                {x.label}
              </button>
            ))}
          </div>
        </div>
        <div data-testid="all-works-grid" className="grid gap-x-5 gap-y-9 mt-10 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
          {list.slice(0, limit).map((p) => <ProjectThumb key={p.id} p={p} />)}
          {!list.length && <p className="col-span-full text-sm text-[#77736B]" data-testid="all-works-empty">Bu kateqoriyada hələ layihə yoxdur.</p>}
        </div>
        {list.length > limit && (
          <div className="mt-10 flex justify-center">
            {standalone ? (
              <button type="button" className="btn-ghost" onClick={() => setLimit((l) => l + step)} data-testid="all-works-more-btn">
                Daha çox göstər ({list.length - limit})
              </button>
            ) : (
              <Link to="/layiheler" className="btn-dark" data-testid="all-works-see-all-btn">
                Bütün işlərə baxın ({list.length}) <ArrowRight size={16} className="arr" />
              </Link>
            )}
          </div>
        )}
        {list.some((p) => p.is_concept) && <p className="text-[11px] text-[#77736B] mt-8">«Konsept» işarəsi olan işlər yanaşmamızı göstərən nümunə layihələrdir, qalanları real müştəri layihələridir.</p>}
      </div>
    </section>
  );
}
